import { ActivityLowestPrice } from "@/types/activities/activities"
import { DayObject } from "@/types/date"
import { EntityRef } from "@/types/entity"
import { TravelerGroup } from "@/types/trip"

import { baseApi } from "./base-api"

export interface GetActivityLowestPriceArgs {
  entityRef: EntityRef
  travelers: TravelerGroup | undefined
  date: DayObject | undefined
}

export const activityApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getActivityLowestPrice: builder.query<
      ActivityLowestPrice,
      GetActivityLowestPriceArgs
    >({
      query: ({ entityRef, travelers, date }) => ({
        url: "/api/activities/lowest_price",
        method: "post",
        data: {
          ...travelers,
          date: date,
          entity_ref: entityRef,
        },
      }),
      providesTags: (_result, _error, { entityRef }) => [
        { type: "ActivityPricing", id: entityRef },
      ],
      keepUnusedDataFor: 900, // 15 minutes
    }),
  }),
})

export const {
  useGetActivityLowestPriceQuery,
  useLazyGetActivityLowestPriceQuery,
} = activityApi
